import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as zopimBootstrapper from "../utils/ZendeskZopimChat";
import * as unifiedBootstrapper from "../utils/ZendeskUnifiedChat";
import Zendesk from "./Zendesk";
import GoogleTagManagerInitializer from "./GoogleTagManagerInitializer";
import { LoginResource, VulcanDataResource } from "@ploy-lib/rest-resources";
import { useResource, useCache } from "@rest-hooks/core";
import { CookieBotPostGtm, CookieBotPreGtm } from "./CookieBot";
import Giosg from "./Giosg";
import Salesforce from "./Salesforce";
import { useContext } from "react";
import { ThirdPartyScriptsContext } from "./ThirdPartyScriptsContext";
export { zendeskIsLoaded } from "../utils/zendeskUtils";
function inIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
const isLocalhost = Boolean(window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
export const ThirdPartyScripts = () => {
    const { isAuthenticated, cookiebotId, googleTagManagerCode, isDirectUser } = useCache(LoginResource.status(), {}) ?? {};
    const isInIframe = inIframe();
    const thirdPartySettings = useContext(ThirdPartyScriptsContext);
    const vulcanData = useResource(VulcanDataResource.detail(), isAuthenticated && !isInIframe ? {} : null);
    const { userFullName, userEmail, roleName, vendorName, customerCategoryId } = vulcanData || {};
    const evaluateLogin = () => {
        if (thirdPartySettings.settings.loadZendeskOnLoginPage) {
            return true;
        }
        return isAuthenticated;
    };
    const zendesk = !((thirdPartySettings.settings.loadZendeskChat ||
        thirdPartySettings.settings.loadDNBFIZendesk) &&
        evaluateLogin()) ? null : (_jsx(Zendesk, { accountKey: customerCategoryId === 2
            ? thirdPartySettings.settings.zendeskAlternativeAccountKey
            : thirdPartySettings.settings.zendeskAccountKey, username: userFullName, email: userEmail, tags: [roleName, vendorName, "Vestlandet"], bootstrapper: thirdPartySettings.settings.loadDNBFIZendesk
            ? unifiedBootstrapper
            : zopimBootstrapper }));
    const giosg = !thirdPartySettings.settings.loadGiosgChat || isDirectUser ? null : (_jsx(Giosg, {}));
    const salesforce = !thirdPartySettings.settings.loadSalesforceChat ||
        !isAuthenticated ||
        isLocalhost ? null : (_jsx(Salesforce, { orgId: thirdPartySettings.settings.salesforceOrgId, embeddedMessagingName: thirdPartySettings.settings.salesforceEmbeddedMessagingName, baseUrl: thirdPartySettings.settings.salesforceBaseUrl, scrt2Url: thirdPartySettings.settings.salesforceScrt2Url, language: thirdPartySettings.settings.salesforceLanguage, username: userEmail }));
    const cookieBotPreGtm = !thirdPartySettings.settings.loadCookieBot ? null : (_jsx(CookieBotPreGtm, {}));
    const gtm = thirdPartySettings.settings.loadGoogleTagManager && googleTagManagerCode ? (_jsx(GoogleTagManagerInitializer, { CustomerCategoryId: customerCategoryId, GoogleTagManagerCode: googleTagManagerCode })) : null;
    const cookieBotPostGtm = thirdPartySettings.settings.loadCookieBot && cookiebotId ? (_jsx(CookieBotPostGtm, { cookiebotId: cookiebotId })) : null;
    return (_jsxs(_Fragment, { children: [zendesk, giosg, salesforce, cookieBotPreGtm, gtm, cookieBotPostGtm] }));
};
//# sourceMappingURL=ThirdPartyScripts.js.map